import React, { Component, Fragment } from "react"
import { NavLink } from 'react-router-dom'
import PersonalStats from './PersonalStats'
import { SORT } from '../../../Templates/functions'
import { renderSortingIcon, toggleSorting } from "../../../Templates/functions";
import SearchFilter from '../../../Templates/SearchFilter'
import { smallCircleSkeleton, smallTextSkeleton, longLineSkeleton } from '../../../Templates/icons'
import {WebSocketEventEmitter} from "../../../Websockets/WebSocketEventEmitter";
class ProgressTracker extends Component {
    state = {
        sortingByProgress: 0,
        sortingByName:2,
        filteredUsers: [],
        loading: false
    }

    componentDidMount = () => {
        const msg = {
            eventSource: 'identify_user',
            sender: "Progress Tracker Widget",
            currentUserId: this.props.currentUserId,
            currentUserRole: this.props.currentUserRole
        }
        WebSocketEventEmitter.emit('WSListener', msg);

        WebSocketEventEmitter.on('ProgressTracker', (msg) => {
            this.props.updateUserAssignmentProgress(msg)
        })
    }

    filterUsersList = (searchText) => {
        if (searchText === "") {
            this.setState(prevState => ({
                filteredUsers: [],
                filteringUsers: false
            }))
        }
        this.setState(prevState => ({
            filteredUsers: this.props.users.filter(user => user.username.toLowerCase().includes(searchText)),
            filteringUsers: true
        }))
    }

    addAdditionalInfo = (users) => {
        // Return a new array; filter out any non-object entries defensively
        return users
            .filter(user => user && typeof user === 'object')
            .map(user => {
                const assignments = Array.isArray(user.assignments) ? user.assignments : [];
                const totalAssignments = assignments.length;
                const totalProgress = assignments.reduce((acc, a) => acc + (Number(a.progress) || 0), 0);
                const progress = totalAssignments ? Math.round(totalProgress / totalAssignments) : 0;
                return { ...user, progress };
            })
    }

    render() {
        let users = Array.isArray(this.props.users) ? this.props.users : []
        users = users.filter(user => user && typeof user === 'object' && user.role !== 'Work Lead')
        users = this.addAdditionalInfo(users)
        users = SORT(2, users, "username")
        if (this.state.filteringUsers) {
            users = this.state.filteredUsers
        }

        // if (this.state.sortingByName) {
        //     users = SORT(this.state.sortingByName, users, "username")
        // }

        if (this.state.sortingByName) {
            users = SORT(this.state.sortingByName, users, "username")
        }
        const ghostItem = <div id="progress-stats-container">
            <div className="flex-centered" style={{ margin: "0em 0" }}>
                {smallCircleSkeleton}
            </div>
            <div id="progress-stats">
                {smallTextSkeleton}
                <div id="progress-bars">
                    {longLineSkeleton}
                </div>
            </div>
        </div>

           return <div className={`feed-item shadow ${this.props.gridlabel}`}>
               <NavLink id="widget-link" className="flex-centered clickable FontSize20" to={`/dashboard/management/users`}
                   draggable={false}>USER
            </NavLink>
               <div className="flex-apart" id="widget-data-search-sort">
                    <SearchFilter filterList={this.filterUsersList} />
                    <div className="flex-apart" style={{ alignItems: "center", color: "#777777"}}>
                       <div className="exception" onClick={() => toggleSorting(this.state.sortingByName, (value) => this.setState({ sortingByName: value }))}>
                        {renderSortingIcon(this.state.sortingByName)}
                        </div>
                    </div>
                </div>
               <ul id="progress-tracker-container" className="overflow-y">
                    {this.state.loading ?
                      <Fragment>
                           {ghostItem}
                           {ghostItem}
                           {ghostItem}
                           {ghostItem}
                           {ghostItem}
                           {ghostItem}
                      </Fragment> :
                    users.length > 0 ? users.map(user => {
                        let sum = 0;
                        let average = 0;
                        if (user.assignments){
                            user.assignments.forEach(assignment => {
                                sum += (Number(assignment.progress) || 0);
                            });
                            average = sum / (user.assignments.length || 1);
                            return <li key={user._id} id="progress-tracker-item">
                                <PersonalStats updatedAt={user.updatedAt} name={user.username} status={user.status} progress={average || 0} image={user.image}/>
                            </li>
                        } else {
                            return <li>No Assignments</li>
                        }
                    }) : null}
                </ul>
            </div>
    }
}

export default ProgressTracker